import LabeledInfo from "./LabeledInfo";

export default LabeledInfo;
